// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__va9Dc","right":"styles_right__26hp6"};